import Vue from "vue";

import CatalogSearch from "./CatalogSearch.vue";

export function load() {
    const selector = "catalog-search";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(CatalogSearch, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}